module.exports = __webpack_public_path__ + "static/media/new_normal.41e69acd.jpg";